import { Duration } from "luxon";
import { types } from "mobx-state-tree";
const triggerTypeModel = types.enumeration([
    "firstTime",
    "repeatedly",
    "unknown",
]);
const feedbacksModel = types.model({
    key: types.string,
    type: triggerTypeModel,
    triggeredAt: types.array(types.number),
    submittedAt: types.maybe(types.number),
    mutedAt: types.maybe(types.number),
});
/**
 * This duration must be elapsed between triggering, to indicate that a feature
 * is used repeatedly over a certain span of time.
 */
const minimumRepeatedlyTimeGap = Duration.fromObject({
    days: 1,
}).toMillis();
/**
 * This is the minimum amount triggering, to indicate that a feature is used
 * repeatedly.
 */
const minimumRepeatedlyTriggers = 3;
const isTriggerDue = (trigger) => {
    if (trigger.submittedAt || trigger.mutedAt || trigger.type === "unknown") {
        return false;
    }
    if (trigger.type === "firstTime") {
        return true;
    }
    // Check "repeatedly conditions"
    if (trigger.triggeredAt.length < minimumRepeatedlyTriggers) {
        return false;
    }
    let prevTimestamp = Number.MAX_VALUE;
    for (const timestamp of trigger.triggeredAt) {
        if (timestamp - prevTimestamp > minimumRepeatedlyTimeGap) {
            return true;
        }
        prevTimestamp = timestamp;
    }
    return false;
};
export const model = types
    .model({
    feedbacks: types.map(feedbacksModel),
})
    .actions((self) => ({
    register: (key, type) => {
        const timestamp = Date.now();
        const trigger = self.feedbacks.get(key) ?? {
            key,
            type,
            triggeredAt: [],
            submittedAt: undefined,
            mutedAt: undefined,
        };
        trigger.triggeredAt.push(timestamp);
        // avoids uncontrolled growing
        trigger.triggeredAt = trigger.triggeredAt.slice(-10);
        trigger.type = type;
        self.feedbacks.set(key, trigger);
    },
    clear: () => {
        self.feedbacks.clear();
    },
    setSubmitted: (key) => {
        const trigger = self.feedbacks.get(key);
        const now = Date.now();
        if (trigger) {
            trigger.submittedAt = now;
        }
        else {
            self.feedbacks.set(key, {
                key,
                type: "unknown",
                submittedAt: now,
            });
        }
    },
    setMuted: (key) => {
        const trigger = self.feedbacks.get(key);
        if (trigger) {
            trigger.mutedAt = Date.now();
        }
    },
    onLoad: () => { },
}))
    .views((self) => {
    const dueFeedbacks = () => Array.from(self.feedbacks.values()).filter(isTriggerDue);
    return {
        dueFeedbacks,
        lastDueFeedback: () => dueFeedbacks()[0],
    };
});
export const userFeedbackStore = model.create({});
export default userFeedbackStore;
//# sourceMappingURL=data:application/json;base64,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